/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Key = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "7.5", cy: "15.5", r: "5.5" }],
    ["path", { d: "m21 2-9.6 9.6" }],
    ["path", { d: "m15.5 7.5 3 3L22 7l-3-3" }]
  ]
];

export { Key as default };
//# sourceMappingURL=key.js.map
